import {Carrier, PolicyRequirementType, PolicyType} from '../../APIs/CustomerPortalAPI';

export const PolicyRequirementTypeOptions = [
    {
        value: PolicyRequirementType.POLICY_DOCUSIGN,
        label: 'Policy Documents',
    },
];

export const CarrierOptions = Object.values(Carrier);

export const ProductTypeOptions = Object.values(PolicyType);
